import { render } from "./SkinQuestionView.vue?vue&type=template&id=73f025fa"
import script from "./SkinQuestionView.vue?vue&type=script&lang=js"
export * from "./SkinQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__